import * as React from "react";
import { graphql } from "gatsby";

import { ThemeContext } from "../context/ThemeContext";

import Layout from "../components/layout";
import Seo from "../components/seo";
import Hero from "../components/shared/hero";
import { FindOther } from "../components/404-page/findOther";

import heroImgPlanet from "images/404/planet_hero.jpeg";
import heroImgPeople from "images/404/people_hero.jpeg";

const NotFoundPage = (props) => {
  const { data } = props;
  const { featuredPosts } = data ?? {};

  // console.debug("404 debug data", props);

  const listOfPosts =
    featuredPosts?.nodes?.map((thePost) => {
      return {
        id: thePost?.id,
        img: null,
        sourceUrl:
          thePost?.globalConfig?.backgroundImage?.sourceUrl ??
          "https://www.gvi.co.uk/wp-content/uploads/2021/11/1515890841-2021-nov-10-13-04-26-000000-Blog-Images-new-editor.png",
        title: thePost?.title,
        desc: thePost?.blogPosts?.blurb ?? "",
        uri: thePost?.uri
      };
    }) ?? [];

  const heroHeadline = {
    template: "404 page",
    title: "404",
    subTitle: {
      planet: "Looks like you got lost in the wilderness!",
      people: "Come back to your people!"
    },
    desc: "Our team of highly skilled developers will get to work finding your way.<br/> In the meantime why not try something else until the problem has been resolved."
  };
  return (
    <ThemeContext.Consumer>
      {(theme) => (
        <Layout
          containerClass={"w-full mx-auto 404-page"}
          brandingOpts={{ ...theme }}
        >
          <Hero
            heroHeadLine={heroHeadline}
            heroImg={
              theme?.currentBrand?.includes("people")
                ? heroImgPeople
                : heroImgPlanet
            }
            navLinks={""}
            videoId={""}
            heroClass={"hero-section"}
          />
          {listOfPosts?.length > 0 && <FindOther articles={listOfPosts} />}
        </Layout>
      )}
    </ThemeContext.Consumer>
  );
};

export const Head = ({ location, params }) => {
  if (
    location?.pathname.includes("/blog/") &&
    process.env.GATSBY_DEFAULT_THEME === "light"
  ) {
    const redirectURL =
      typeof window !== "undefined" &&
      !window?.location?.href?.includes("localhost") &&
      !window?.location?.href?.includes("netlify.app")
        ? window?.location?.href?.replace("people.", "www.")
        : ["https://go.gviworld.com", location.pathname].join("");
    // console.debug("its a lost blog!!", {
    //   location,
    //   params,
    //   redirectURL
    // });
    return <meta httpEquiv="refresh" content={`0; URL=${redirectURL}`} />;
  }

  return (
    <Seo
      title={" Error 404 (Not Found)"}
      meta={[{ name: "robots", content: "noindex" }]}
    />
  );
};

export const pageQuery = graphql`
  query {
    featuredPosts: allWpPost(
      filter: { blogPosts: { featuredBlog: { eq: true } } }
      sort: { date: DESC }
      limit: 4
    ) {
      nodes {
        ...featuredEditorial
      }
    }
  }
`;

export default NotFoundPage;
